import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App';
import reportWebVitals from './reportWebVitals';
//import Popper from 'popper.js';

//import '../node_modules/popper.js/dist/popper-utils.min.js';
//import '../node_modules/bootstrap/dist/css/bootstrap.css';

import "../node_modules/bootstrap/dist/css/bootstrap.min.css";

console.log("index.js REACT_APP_API_URL:", process.env.REACT_APP_API_URL);  // Add this line

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
